import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

export const ShebaFieldMask = forwardRef<HTMLElement, any>(
    function TextMaskCustom(props: any, ref: any) {
        const { onChange, maskLazy = false, ...other } = props;

        return (
            <IMaskInput
                {...other}
                mask="0000 0000 0000 0000 0000 0000"
                lazy={maskLazy}
                definitions={{
                    '#': /[1-9]/,
                }}
                inputRef={ref}
                onAccept={(value: any) => {
                    onChange({
                        target: {
                            name:
                                props.name !== undefined
                                    ? props.name
                                    : Date.now(),
                            value: value,
                        },
                    });
                }}
                overwrite
            />
        );
    },
);
